<!-- TABLEAU GESTION ISO-->
<p-table #dt [rowHover]="true" [rowsPerPageOptions]="[10,25,50]" styleClass="ui-table-customers" [columns]="echantillonIsoCols" [value]="echantillonsIso" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Ligne {first} à {last} sur {totalRecords} lignes">
    <ng-template pTemplate="caption" style="width: 100%;">
        <p-button [style]="{'float':'left'}" type="button"  class="btn-modif p-col-1" icon="pi pi-plus-circle" (click)="showAjoutIso()"></p-button>
    </ng-template>

    <ng-template pTemplate="header">
        <tr>
            <th *ngFor="let col of echantillonIsoCols" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field" ></p-sortIcon>
            </th>
        </tr>

    </ng-template>

    <ng-template pTemplate="body" let-echantillon let-columns="columns">
        <tr>
            <td *ngFor="let col of columns">
                <span>
                    {{echantillon[col.field]}}
                </span>    
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
        </tr>
    </ng-template>
</p-table>
<!-- FIN TABLEAU GESTION ISO-->


<!-- DIALOGUE AJOUT ECHANTILLONAGE ISO -->
<p-dialog header="Ajout estimation" [(visible)]="ajoutEchantillonageIso" [style]="{width: '30vw'}" [baseZIndex]="10000">
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-grid">
                <div class="p-col-12">
                    Nombre estimé :
                </div>
                <p-inputNumber class="p-col-12" [(ngModel)]="estimation" [showButtons]="true" buttonLayout="horizontal" spinnerMode="horizontal" [step]="1" decrementButtonClass="ui-button-danger" incrementButtonClass="ui-button-success" incrementButtonIcon="pi pi-plus" [min]="0" decrementButtonIcon="pi pi-minus" mode="decimal" >
                </p-inputNumber>
            </div>
        </div>
        <!-- <div class="p-col-4">
            <div class="p-grid">
                <div class="p-col-12">
                    Date de l'estimation :
                </div>
                <div class="p-col-12">
                    <p-calendar [locale]="fr" [baseZIndex]="10001" [appendTo]="'body'"  [showButtonBar]="true" styleClass="ui-column-filter" [(ngModel)]="dateEstimation" placeholder="Estimation pour la date" [readonlyInput]="true" dateFormat="dd/mm/yy" ></p-calendar>
                </div>
            </div>
        </div> -->
    </div>
    <p-footer>
        <p-button icon="pi pi-check"  label="Enregistrer" class="ui-button-info" (click)="ajoutEchantillonIso()"></p-button>
        <p-button icon="pi pi-times"  label="Annuler" (click)="cancelAjoutIso()"></p-button>
    </p-footer>
</p-dialog>
<!-- FIN AJOUT ECHANTILLONAGE ISO -->